import {
  DataFeed,
  ProductAccountTypes,
  PaymentGateway,
  TOption,
  TradingPlatForms,
} from '@src/types';

export const dataFeeds: DataFeed[] = [
  {
    id: TradingPlatForms.CQG_DATA_FEED,
    name: 'CQG Data Feed',
    recommended: true,
    platforms: [
      // '/assets/checkout/ninja-trader.png', // COMMENTED OUT
      '/assets/checkout/tradovate.png',
      '/assets/checkout/trading-view.png',
    ],
  },
  {
    id: TradingPlatForms.RITHMIC_DATA_FEED,
    name: 'Rithmic Data Feed',
    platforms: ['/assets/checkout/r-trader-pro.png'],
  },
  // DX_DATA_FEED - Commented out
  // {
  //   id: TradingPlatForms.DX_DATA_FEED,
  //   name: 'DX Data Feed',
  //   platforms: [
  //     '/assets/checkout/volumetrica-trading.png',
  //     '/assets/checkout/volsys.png',
  //     '/assets/checkout/volbook.png',
  //   ],
  // },
  {
    id: `${TradingPlatForms.CQG_DATA_FEED}-1` as TradingPlatForms,
    name: 'CQG Data Feed',
    recommended: true,
    platforms: [
      // '/assets/checkout/ninja-trader.png', // COMMENTED OUT
      '/assets/checkout/tradovate.png',
      '/assets/checkout/trading-view.png',
    ],
  },
  {
    id: `${TradingPlatForms.RITHMIC_DATA_FEED}-1` as TradingPlatForms,
    name: 'Rithmic Data Feed',
    platforms: ['/assets/checkout/r-trader-pro.png'],
  },
];

export const accountTypes = [
  {
    label: 'Foundation',
    value: ProductAccountTypes.FOUNDATION,
  },
  {
    label: 'Bundles',
    value: ProductAccountTypes.BUNDLE,
  },
  {
    label: 'Entry',
    value: ProductAccountTypes.ENTRY,
  },
  {
    label: 'Weekly',
    value: ProductAccountTypes.WEEKLY,
  },
];

export const paymentCheckboxData: TOption[] = [
  {
    label: 'Stripe',
    value: PaymentGateway.STRIPE,
    url: '/assets/stripe.png',
    width: 25,
    height: 9.95,
  },
  {
    label: 'Paypal',
    value: PaymentGateway.PAYPAL,
    url: '/assets/paypal.png',
    width: 30,
    height: 8,
  },
];
